import "./HelpDropdown.css";
import { useEffect, useState, useRef } from "react";

function HelpDropdown() {
  const [open, setOpen] = useState(false);

  let menuRef = useRef();

  useEffect(() => {
    let handler = (e) => {
      if (!menuRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handler);

    return () => {
      document.removeEventListener("mousedown", handler);
    };
  });

  const handleSelect = (branch) => {
    // setSelectedBranch(branch);
    setOpen(false);
  };

  return (
    <div className="App">
      <div className="help-menu-container" ref={menuRef}>
        <div
          className="menu-trigger"
          onClick={() => {
            setOpen(!open);
          }}
        >
          <div className="helpsprite"></div>
        </div>

        <div className={`help-dropdown-menu ${open ? "active" : "inactive"}`}>
          {/* <h3>
            Person Name
            <br />
            <span>Designation</span>
          </h3> */}
          <div className="list">
            <DropdownItem
              text={"Click on this link for Help"}
              onselect={handleSelect}
            />
          </div>
        </div>
      </div>
    </div>
  ); 
}

function DropdownItem(props) {
  return (
    <li className="help-dropdownItem" onClick={() => props.onselect()}>
      <a>{props.text}</a>
    </li>
  );
}

export default HelpDropdown;
